const symbols = [
  {
    "web-scraper-order": "1666026561-1284",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔲 Black Square Button",
    "symbols-href": "https://emojipedia.org/black-square-button/",
    emoji: "🔲",
    emojiName: "🔲 Black Square Button",
    description:
      "Black Square Button was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026564-1286",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔳 White Square Button",
    "symbols-href": "https://emojipedia.org/white-square-button/",
    emoji: "🔳",
    emojiName: "🔳 White Square Button",
    description: "White Square Button.",
  },
  {
    "web-scraper-order": "1666026568-1288",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔘 Radio Button",
    "symbols-href": "https://emojipedia.org/radio-button/",
    emoji: "🔘",
    emojiName: "🔘 Radio Button",
    description:
      "A radio button user interface element, used in form fields with two or more choices. Differs from a checkbox, in that only one response can be selected.",
  },
  {
    "web-scraper-order": "1666026571-1289",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💠 Diamond with a Dot",
    "symbols-href": "https://emojipedia.org/diamond-with-a-dot/",
    emoji: "💠",
    emojiName: "💠 Diamond with a Dot",
    description:
      "A glyph that is used for kawaii in Japan, resembling the shape of a flower.",
  },
  {
    "web-scraper-order": "1666026574-1291",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔻 Red Triangle Pointed Down",
    "symbols-href": "https://emojipedia.org/red-triangle-pointed-down/",
    emoji: "🔻",
    emojiName: "🔻 Red Triangle Pointed Down",
    description:
      "Red Triangle Pointed Down was approved as part of Unicode 6.0 in 2010 under the name “Down-Pointing Red Triangle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026577-1293",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔺 Red Triangle Pointed Up",
    "symbols-href": "https://emojipedia.org/red-triangle-pointed-up/",
    emoji: "🔺",
    emojiName: "🔺 Red Triangle Pointed Up",
    description:
      "Red Triangle Pointed Up was approved as part of Unicode 6.0 in 2010 under the name “Up-Pointing Red Triangle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026580-1295",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔹 Small Blue Diamond",
    "symbols-href": "https://emojipedia.org/small-blue-diamond/",
    emoji: "🔹",
    emojiName: "🔹 Small Blue Diamond",
    description:
      "Small Blue Diamond was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026584-1297",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔸 Small Orange Diamond",
    "symbols-href": "https://emojipedia.org/small-orange-diamond/",
    emoji: "🔸",
    emojiName: "🔸 Small Orange Diamond",
    description: "A small version of the large orange diamond emoji.",
  },
  {
    "web-scraper-order": "1666026587-1299",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔷 Large Blue Diamond",
    "symbols-href": "https://emojipedia.org/large-blue-diamond/",
    emoji: "🔷",
    emojiName: "🔷 Large Blue Diamond",
    description:
      "Large Blue Diamond was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026591-1301",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔶 Large Orange Diamond",
    "symbols-href": "https://emojipedia.org/large-orange-diamond/",
    emoji: "🔶",
    emojiName: "🔶 Large Orange Diamond",
    description: "A larger version of the small orange diamond emoji.",
  },
  {
    "web-scraper-order": "1666026594-1303",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▫️ White Small Square",
    "symbols-href": "https://emojipedia.org/white-small-square/",
    emoji: "▫️",
    emojiName: "▫️ White Small Square",
    description:
      "White Small Square was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026599-1306",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▪️ Black Small Square",
    "symbols-href": "https://emojipedia.org/black-small-square/",
    emoji: "▪️",
    emojiName: "▪️ Black Small Square",
    description:
      "Black Small Square was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026602-1307",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◽ White Medium-Small Square",
    "symbols-href": "https://emojipedia.org/white-medium-small-square/",
    emoji: "◽",
    emojiName: "◽ White Medium-Small Square",
    description:
      "White Medium-Small Square was approved as part of Unicode 3.2 in 2002 under the name “White Medium Small Square” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026604-1309",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◾ Black Medium-Small Square",
    "symbols-href": "https://emojipedia.org/black-medium-small-square/",
    emoji: "◾",
    emojiName: "◾ Black Medium-Small Square",
    description:
      "Black Medium-Small Square was approved as part of Unicode 3.2 in 2002 under the name “Black Medium Small Square” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026609-1311",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◻️ White Medium Square",
    "symbols-href": "https://emojipedia.org/white-medium-square/",
    emoji: "◻️",
    emojiName: "◻️ White Medium Square",
    description:
      "White Medium Square was approved as part of Unicode 3.2 in 2002 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026613-1313",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◼️ Black Medium Square",
    "symbols-href": "https://emojipedia.org/black-medium-square/",
    emoji: "◼️",
    emojiName: "◼️ Black Medium Square",
    description:
      "Black Medium Square was approved as part of Unicode 3.2 in 2002 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026616-1315",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬜ White Large Square",
    "symbols-href": "https://emojipedia.org/white-large-square/",
    emoji: "⬜",
    emojiName: "⬜ White Large Square",
    description:
      "A square shown in the shade of white. May be used to represent anything white.",
  },
  {
    "web-scraper-order": "1666026619-1317",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬛ Black Large Square",
    "symbols-href": "https://emojipedia.org/black-large-square/",
    emoji: "⬛",
    emojiName: "⬛ Black Large Square",
    description:
      "A square shown in the shade of black. May be used to represent anything black.",
  },
  {
    "web-scraper-order": "1666026622-1319",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟫 Brown Square",
    "symbols-href": "https://emojipedia.org/large-brown-square/",
    emoji: "🟫",
    emojiName: "🟫 Brown Square",
    description:
      "A square shown in the color of brown. May be used to represent anything brown.",
  },
  {
    "web-scraper-order": "1666026625-1320",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟪 Purple Square",
    "symbols-href": "https://emojipedia.org/large-purple-square/",
    emoji: "🟪",
    emojiName: "🟪 Purple Square",
    description:
      "A square shown in the color of purple. May be used to represent anything purple.",
  },
  {
    "web-scraper-order": "1666026628-1322",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟦 Blue Square",
    "symbols-href": "https://emojipedia.org/large-blue-square/",
    emoji: "🟦",
    emojiName: "🟦 Blue Square",
    description:
      "A square shown in the color of blue. May be used to represent anything blue.",
  },
  {
    "web-scraper-order": "1666026630-1324",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟩 Green Square",
    "symbols-href": "https://emojipedia.org/large-green-square/",
    emoji: "🟩",
    emojiName: "🟩 Green Square",
    description:
      "A square shown in the color of green. May be used to represent anything green.",
  },
  {
    "web-scraper-order": "1666026633-1325",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟨 Yellow Square",
    "symbols-href": "https://emojipedia.org/large-yellow-square/",
    emoji: "🟨",
    emojiName: "🟨 Yellow Square",
    description:
      "A square shown in the color yellow. May be used to represent anything yellow, including a yellow penalty card in football (soccer).",
  },
  {
    "web-scraper-order": "1666026635-1327",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟧 Orange Square",
    "symbols-href": "https://emojipedia.org/large-orange-square/",
    emoji: "🟧",
    emojiName: "🟧 Orange Square",
    description:
      "A square shown in the color of orange. May be used to represent anything orange.",
  },
  {
    "web-scraper-order": "1666026638-1328",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟥 Red Square",
    "symbols-href": "https://emojipedia.org/large-red-square/",
    emoji: "🟥",
    emojiName: "🟥 Red Square",
    description:
      "A square shown in the color red. May be used to represent anything red, including a red penalty card in football (soccer).",
  },
  {
    "web-scraper-order": "1666026640-1329",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚪ White Circle",
    "symbols-href": "https://emojipedia.org/white-circle/",
    emoji: "⚪",
    emojiName: "⚪ White Circle",
    description:
      "White Circle was approved as part of Unicode 4.1 in 2005 under the name “Medium White Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026643-1330",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚫ Black Circle",
    "symbols-href": "https://emojipedia.org/black-circle/",
    emoji: "⚫",
    emojiName: "⚫ Black Circle",
    description:
      "Black Circle was approved as part of Unicode 4.1 in 2005 under the name “Medium Black Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026646-1331",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟤 Brown Circle",
    "symbols-href": "https://emojipedia.org/large-brown-circle/",
    emoji: "🟤",
    emojiName: "🟤 Brown Circle",
    description:
      "Brown Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Brown Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026648-1332",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟣 Purple Circle",
    "symbols-href": "https://emojipedia.org/large-purple-circle/",
    emoji: "🟣",
    emojiName: "🟣 Purple Circle",
    description:
      "Purple Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Purple Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026651-1333",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔵 Blue Circle",
    "symbols-href": "https://emojipedia.org/large-blue-circle/",
    emoji: "🔵",
    emojiName: "🔵 Blue Circle",
    description:
      "Blue Circle was approved as part of Unicode 6.0 in 2010 under the name “Large Blue Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026653-1334",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟢 Green Circle",
    "symbols-href": "https://emojipedia.org/large-green-circle/",
    emoji: "🟢",
    emojiName: "🟢 Green Circle",
    description:
      "Green Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Green Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026656-1335",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟡 Yellow Circle",
    "symbols-href": "https://emojipedia.org/large-yellow-circle/",
    emoji: "🟡",
    emojiName: "🟡 Yellow Circle",
    description:
      "Yellow Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Yellow Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026658-1336",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟠 Orange Circle",
    "symbols-href": "https://emojipedia.org/large-orange-circle/",
    emoji: "🟠",
    emojiName: "🟠 Orange Circle",
    description:
      "Orange Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Orange Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026661-1337",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔴 Red Circle",
    "symbols-href": "https://emojipedia.org/large-red-circle/",
    emoji: "🔴",
    emojiName: "🔴 Red Circle",
    description:
      "Red Circle was approved as part of Unicode 6.0 in 2010 under the name “Large Red Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026664-1338",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈵 Japanese “No Vacancy” Button",
    "symbols-href": "https://emojipedia.org/japanese-no-vacancy-button/",
    emoji: "🈵",
    emojiName: "🈵 Japanese “No Vacancy” Button",
    description:
      "This emoji means “full” in Japanese, usually used to denote “full capacity” such as a gas/petrol tank on a car or pre-paid phone card.",
  },
  {
    "web-scraper-order": "1666026668-1340",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈺 Japanese “Open for Business” Button",
    "symbols-href": "https://emojipedia.org/japanese-open-for-business-button/",
    emoji: "🈺",
    emojiName: "🈺 Japanese “Open for Business” Button",
    description:
      "Means “work” in Japanese.  This Emoji used to mean “open for business” and precedes business hours.",
  },
  {
    "web-scraper-order": "1666026671-1342",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "㊙️ Japanese “Secret” Button",
    "symbols-href": "https://emojipedia.org/japanese-secret-button/",
    emoji: "㊙️",
    emojiName: "㊙️ Japanese “Secret” Button",
    description:
      "Japanese “Secret” Button was approved as part of Unicode 1.1 in 1993 under the name “Circled Ideograph Secret” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026675-1345",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "㊗️ Japanese “Congratulations” Button",
    "symbols-href": "https://emojipedia.org/japanese-congratulations-button/",
    emoji: "㊗️",
    emojiName: "㊗️ Japanese “Congratulations” Button",
    description:
      'Translated from Japanese, this means "congratulations" or "pray for happiness".',
  },
  {
    "web-scraper-order": "1666026678-1347",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈳 Japanese “Vacancy” Button",
    "symbols-href": "https://emojipedia.org/japanese-vacancy-button/",
    emoji: "🈳",
    emojiName: "🈳 Japanese “Vacancy” Button",
    description:
      "This 空 character means empty and available in Japanese. This is used in the context of an empty parking space or a vacant hotel room.",
  },
  {
    "web-scraper-order": "1666026681-1349",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈴 Japanese “Passing Grade” Button",
    "symbols-href": "https://emojipedia.org/japanese-passing-grade-button/",
    emoji: "🈴",
    emojiName: "🈴 Japanese “Passing Grade” Button",
    description:
      "Means “agreement” in Japanese. More literally, it means to unite, or join together.",
  },
  {
    "web-scraper-order": "1666026684-1351",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈸 Japanese “Application” Button",
    "symbols-href": "https://emojipedia.org/japanese-application-button/",
    emoji: "🈸",
    emojiName: "🈸 Japanese “Application” Button",
    description: "This Emoji has two meanings.",
  },
  {
    "web-scraper-order": "1666026687-1354",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🉑 Japanese “Acceptable” Button",
    "symbols-href": "https://emojipedia.org/japanese-acceptable-button/",
    emoji: "🉑",
    emojiName: "🉑 Japanese “Acceptable” Button",
    description:
      "Japanese “Acceptable” Button was approved as part of Unicode 6.0 in 2010 under the name “Circled Ideograph Accept” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026692-1356",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈲 Japanese “Prohibited” Button",
    "symbols-href": "https://emojipedia.org/japanese-prohibited-button/",
    emoji: "🈲",
    emojiName: "🈲 Japanese “Prohibited” Button",
    description: "This Emoji means “prohibit, restrict or forbid” in Japanese.",
  },
  {
    "web-scraper-order": "1666026696-1359",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈚 Japanese “Free of Charge” Button",
    "symbols-href": "https://emojipedia.org/japanese-free-of-charge-button/",
    emoji: "🈚",
    emojiName: "🈚 Japanese “Free of Charge” Button",
    description: "This means to lack, or have none of something.",
  },
  {
    "web-scraper-order": "1666026700-1361",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈹 Japanese “Discount” Button",
    "symbols-href": "https://emojipedia.org/japanese-discount-button/",
    emoji: "🈹",
    emojiName: "🈹 Japanese “Discount” Button",
    description:
      "Symbol for a sale, or bargain prices in Japan (“cut prices”). Literally translated, this character means to cut or divide.",
  },
  {
    "web-scraper-order": "1666026704-1363",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🉐 Japanese “Bargain” Button",
    "symbols-href": "https://emojipedia.org/japanese-bargain-button/",
    emoji: "🉐",
    emojiName: "🉐 Japanese “Bargain” Button",
    description: "Denotes a “good bargain” in Japanese.",
  },
  {
    "web-scraper-order": "1666026708-1365",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈯 Japanese “Reserved” Button",
    "symbols-href": "https://emojipedia.org/japanese-reserved-button/",
    emoji: "🈯",
    emojiName: "🈯 Japanese “Reserved” Button",
    description:
      "This character translates as meaning a finger or toe pointing to indicate a certain direction.",
  },
  {
    "web-scraper-order": "1666026712-1367",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈶 Japanese “Not Free of Charge” Button",
    "symbols-href":
      "https://emojipedia.org/japanese-not-free-of-charge-button/",
    emoji: "🈶",
    emojiName: "🈶 Japanese “Not Free of Charge” Button",
    description: "This emoji means to own or posses.",
  },
  {
    "web-scraper-order": "1666026716-1370",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈷️ Japanese “Monthly Amount” Button",
    "symbols-href": "https://emojipedia.org/japanese-monthly-amount-button/",
    emoji: "🈷️",
    emojiName: "🈷️ Japanese “Monthly Amount” Button",
    description:
      "CJK Ideographs are characters used in Chinese, Japanese and Korean languages. Their writing systems all completely or partly use Chinese characters.",
  },
  {
    "web-scraper-order": "1666026719-1372",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈂️ Japanese “Service Charge” Button",
    "symbols-href": "https://emojipedia.org/japanese-service-charge-button/",
    emoji: "🈂️",
    emojiName: "🈂️ Japanese “Service Charge” Button",
    description:
      'Translates as meaning complimentary, or free of charge. For example, a drink that is given "on the house" to a regular customer.',
  },
  {
    "web-scraper-order": "1666026724-1375",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈁 Japanese “Here” Button",
    "symbols-href": "https://emojipedia.org/japanese-here-button/",
    emoji: "🈁",
    emojiName: "🈁 Japanese “Here” Button",
    description: "Means “Here” in Japanese, referring to a destination.",
  },
  {
    "web-scraper-order": "1666026737-1376",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆚 Vs Button",
    "symbols-href": "https://emojipedia.org/vs-button/",
    emoji: "🆚",
    emojiName: "🆚 Vs Button",
    description:
      "Vs Button was approved as part of Unicode 6.0 in 2010 under the name “Squared Vs” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026740-1377",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆙 Up! Button",
    "symbols-href": "https://emojipedia.org/up-button/",
    emoji: "🆙",
    emojiName: "🆙 Up! Button",
    description:
      "The word up with an exclamation point after it, shown enclosed in a square. Originally intended to denote leveling up in a game.",
  },
  {
    "web-scraper-order": "1666026742-1379",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆘 SOS Button",
    "symbols-href": "https://emojipedia.org/sos-button/",
    emoji: "🆘",
    emojiName: "🆘 SOS Button",
    description:
      "SOS is the description for the distress signal in Morse Code. This emoji means SOS or “emergency”.",
  },
  {
    "web-scraper-order": "1666026745-1381",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅿️ P Button",
    "symbols-href": "https://emojipedia.org/p-button/",
    emoji: "🅿️",
    emojiName: "🅿️ P Button",
    description:
      "Depicted by major emoji vendors as blue square with a white letter 'P' contained within it. Most often to represent a parking space or parking lot.",
  },
  {
    "web-scraper-order": "1666026748-1383",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆗 OK Button",
    "symbols-href": "https://emojipedia.org/ok-button/",
    emoji: "🆗",
    emojiName: "🆗 OK Button",
    description:
      "The letters OK, shown enclosed in a square. Meaning Okay, denoting approval. The opposite of the Squared NG Emoji.",
  },
  {
    "web-scraper-order": "1666026751-1385",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅾️ O Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/o-button-blood-type/",
    emoji: "🅾️",
    emojiName: "🅾️ O Button (Blood Type)",
    description:
      "A symbol representing Blood Type O. Displayed as the letter O on a red background.",
  },
  {
    "web-scraper-order": "1666026753-1387",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆖 NG Button",
    "symbols-href": "https://emojipedia.org/ng-button/",
    emoji: "🆖",
    emojiName: "🆖 NG Button",
    description:
      "The letters NG, shown enclosed in a square, which are an acronym for the words No Good.",
  },
  {
    "web-scraper-order": "1666026755-1389",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆕 New Button",
    "symbols-href": "https://emojipedia.org/new-button/",
    emoji: "🆕",
    emojiName: "🆕 New Button",
    description: "The word new, shown enclosed in a square.",
  },
  {
    "web-scraper-order": "1666026758-1391",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "Ⓜ️ Circled M",
    "symbols-href": "https://emojipedia.org/circled-m/",
    emoji: "Ⓜ️",
    emojiName: "Ⓜ️ Circled M",
    description:
      "The letter M in a circle, commonly used in to identify a Metro (subway, underground train) station in a city area.",
  },
  {
    "web-scraper-order": "1666026761-1393",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆔 ID Button",
    "symbols-href": "https://emojipedia.org/id-button/",
    emoji: "🆔",
    emojiName: "🆔 ID Button",
    description: "The letters ID in a square.",
  },
  {
    "web-scraper-order": "1666026763-1395",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "ℹ️ Information",
    "symbols-href": "https://emojipedia.org/information/",
    emoji: "ℹ️",
    emojiName: "ℹ️ Information",
    description:
      "A lowercase letter i, enclosed in a rounded square or circle. Implemented in apps or websites to indicate that help or further information is available.",
  },
  {
    "web-scraper-order": "1666026765-1397",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆓 Free Button",
    "symbols-href": "https://emojipedia.org/free-button/",
    emoji: "🆓",
    emojiName: "🆓 Free Button",
    description: "The word free, shown enclosed in a square.",
  },
  {
    "web-scraper-order": "1666026770-1400",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆒 Cool Button",
    "symbols-href": "https://emojipedia.org/cool-button/",
    emoji: "🆒",
    emojiName: "🆒 Cool Button",
    description:
      "The word cool, shown enclosed in a square. This generally displays in a shade of blue, or blue-gray on most platforms. Used as a text decoration.",
  },
  {
    "web-scraper-order": "1666026773-1402",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆑 CL Button",
    "symbols-href": "https://emojipedia.org/cl-button/",
    emoji: "🆑",
    emojiName: "🆑 CL Button",
    description:
      "CL is what shows on the CLear button of some older mobile phones.",
  },
  {
    "web-scraper-order": "1666026776-1404",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅱️ B Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/b-button-blood-type/",
    emoji: "🅱️",
    emojiName: "🅱️ B Button (Blood Type)",
    description:
      "A symbol representing Blood Type B. Displayed as the letter B on a red background.",
  },
  {
    "web-scraper-order": "1666026778-1406",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆎 AB Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/ab-button-blood-type/",
    emoji: "🆎",
    emojiName: "🆎 AB Button (Blood Type)",
    description:
      "A symbol representing Blood Type AB. Displayed as the letters AB on a red background.",
  },
  {
    "web-scraper-order": "1666026781-1408",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅰️ A Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/a-button-blood-type/",
    emoji: "🅰️",
    emojiName: "🅰️ A Button (Blood Type)",
    description:
      "A symbol representing Blood Type A. Displayed as the letter A on a red background.",
  },
  {
    "web-scraper-order": "1666026783-1410",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔤 Input Latin Letters",
    "symbols-href": "https://emojipedia.org/input-latin-letters/",
    emoji: "🔤",
    emojiName: "🔤 Input Latin Letters",
    description:
      "A symbol showing the lowercase letters a, b, c and d. Intended to be used on a software keyboard, or other input screen to enable alphabetical input, as opposed to numeric or symbol input.",
  },
  {
    "web-scraper-order": "1666026786-1412",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔣 Input Symbols",
    "symbols-href": "https://emojipedia.org/input-symbols/",
    emoji: "🔣",
    emojiName: "🔣 Input Symbols",
    description:
      "A symbol showing the following glyphs: 〒 (Japanese postal mark), 𝅘𝅥𝅮 (music note), & (ampersand, or sometimes an @ symbol) and % (percentage sign).",
  },
  {
    "web-scraper-order": "1666026789-1414",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔢 Input Numbers",
    "symbols-href": "https://emojipedia.org/input-numbers/",
    emoji: "🔢",
    emojiName: "🔢 Input Numbers",
    description:
      "A symbol showing the numbers 1, 2, 3 and 4. Intended to be used on a software keyboard, or other input screen to enable symbol input, as opposed to alphabetical or symbol input.",
  },
  {
    "web-scraper-order": "1666026791-1416",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔡 Input Latin Lowercase",
    "symbols-href": "https://emojipedia.org/input-latin-lowercase/",
    emoji: "🔡",
    emojiName: "🔡 Input Latin Lowercase",
    description:
      "A symbol showing the lowercase letters a, b, c and d. Intended to be used on a software keyboard, or other input screen to toggle lowercase letter input.",
  },
  {
    "web-scraper-order": "1666026794-1418",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔠 Input Latin Uppercase",
    "symbols-href": "https://emojipedia.org/input-latin-uppercase/",
    emoji: "🔠",
    emojiName: "🔠 Input Latin Uppercase",
    description:
      "A symbol showing the capital letters A, B, C and D. Intended to be used on a software keyboard, or other input screen to toggle capital letter input.",
  },
  {
    "web-scraper-order": "1666026796-1420",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔟 Keycap: 10",
    "symbols-href": "https://emojipedia.org/keycap-10/",
    emoji: "🔟",
    emojiName: "🔟 Keycap: 10",
    description:
      "The number 10 on a square with rounded corners, designed to look like a keycap.",
  },
  {
    "web-scraper-order": "1666026799-1422",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "9️⃣ Keycap Digit Nine",
    "symbols-href": "https://emojipedia.org/keycap-digit-nine/",
    emoji: "9️⃣",
    emojiName: "9️⃣ Keycap Digit Nine",
    description:
      "The Keycap Digit Nine emoji is a keycap sequence combining 9️ Digit Nine and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026802-1424",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "8️⃣ Keycap Digit Eight",
    "symbols-href": "https://emojipedia.org/keycap-digit-eight/",
    emoji: "8️⃣",
    emojiName: "8️⃣ Keycap Digit Eight",
    description:
      "The Keycap Digit Eight emoji is a keycap sequence combining 8️ Digit Eight and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026805-1426",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "7️⃣ Keycap Digit Seven",
    "symbols-href": "https://emojipedia.org/keycap-digit-seven/",
    emoji: "7️⃣",
    emojiName: "7️⃣ Keycap Digit Seven",
    description:
      "The Keycap Digit Seven emoji is a keycap sequence combining 7️ Digit Seven and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026808-1428",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "6️⃣ Keycap Digit Six",
    "symbols-href": "https://emojipedia.org/keycap-digit-six/",
    emoji: "6️⃣",
    emojiName: "6️⃣ Keycap Digit Six",
    description:
      "The Keycap Digit Six emoji is a keycap sequence combining 6️ Digit Six and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026810-1430",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "5️⃣ Keycap Digit Five",
    "symbols-href": "https://emojipedia.org/keycap-digit-five/",
    emoji: "5️⃣",
    emojiName: "5️⃣ Keycap Digit Five",
    description:
      "The Keycap Digit Five emoji is a keycap sequence combining 5️ Digit Five and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026812-1432",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "4️⃣ Keycap Digit Four",
    "symbols-href": "https://emojipedia.org/keycap-digit-four/",
    emoji: "4️⃣",
    emojiName: "4️⃣ Keycap Digit Four",
    description:
      "The Keycap Digit Four emoji is a keycap sequence combining 4️ Digit Four and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026815-1433",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "3️⃣ Keycap Digit Three",
    "symbols-href": "https://emojipedia.org/keycap-digit-three/",
    emoji: "3️⃣",
    emojiName: "3️⃣ Keycap Digit Three",
    description:
      "The Keycap Digit Three emoji is a keycap sequence combining 3️ Digit Three and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026817-1435",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "2️⃣ Keycap Digit Two",
    "symbols-href": "https://emojipedia.org/keycap-digit-two/",
    emoji: "2️⃣",
    emojiName: "2️⃣ Keycap Digit Two",
    description:
      "The Keycap Digit Two emoji is a keycap sequence combining 2️ Digit Two and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026819-1437",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "1️⃣ Keycap Digit One",
    "symbols-href": "https://emojipedia.org/keycap-digit-one/",
    emoji: "1️⃣",
    emojiName: "1️⃣ Keycap Digit One",
    description:
      "The Keycap Digit One emoji is a keycap sequence combining 1️ Digit One and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026822-1439",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "0️⃣ Keycap Digit Zero",
    "symbols-href": "https://emojipedia.org/keycap-digit-zero/",
    emoji: "0️⃣",
    emojiName: "0️⃣ Keycap Digit Zero",
    description:
      "The Keycap Digit Zero emoji is a keycap sequence combining 0️ Digit Zero and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026825-1441",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "*️⃣ Keycap Asterisk",
    "symbols-href": "https://emojipedia.org/keycap-asterisk/",
    emoji: "*️⃣",
    emojiName: "*️⃣ Keycap Asterisk",
    description:
      "The Keycap Asterisk emoji is a keycap sequence combining *️ Asterisk and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026828-1443",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "#️⃣ Keycap Number Sign",
    "symbols-href": "https://emojipedia.org/keycap-number-sign/",
    emoji: "#️⃣",
    emojiName: "#️⃣ Keycap Number Sign",
    description:
      "A hash key, sometimes referred to as a pound key in the United States. Most commonly used online to make a hashtag (or hash flag) on social media sites.",
  },
  {
    "web-scraper-order": "1666026830-1445",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "™️ Trade Mark",
    "symbols-href": "https://emojipedia.org/trade-mark/",
    emoji: "™️",
    emojiName: "™️ Trade Mark",
    description:
      "A trademark symbol, the letters TM displayed after a word that is trademarked.",
  },
  {
    "web-scraper-order": "1666026832-1447",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "®️ Registered",
    "symbols-href": "https://emojipedia.org/registered/",
    emoji: "®️",
    emojiName: "®️ Registered",
    description:
      "Registered was approved as part of Unicode 1.1 in 1993 under the name “Registered Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026835-1449",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "©️ Copyright",
    "symbols-href": "https://emojipedia.org/copyright/",
    emoji: "©️",
    emojiName: "©️ Copyright",
    description:
      "Copyright was approved as part of Unicode 1.1 in 1993 under the name “Copyright Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026837-1451",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❇️ Sparkle",
    "symbols-href": "https://emojipedia.org/sparkle/",
    emoji: "❇️",
    emojiName: "❇️ Sparkle",
    description:
      "Used a decorative bullet-point, the sparkle has both a ❇︎ text and ❇️ emoji presentation available on most platforms.",
  },
  {
    "web-scraper-order": "1666026840-1453",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✴️ Eight-Pointed Star",
    "symbols-href": "https://emojipedia.org/eight-pointed-star/",
    emoji: "✴️",
    emojiName: "✴️ Eight-Pointed Star",
    description:
      "A star with eight points, that is commonly shown in orange, and for some reason, with only four points.",
  },
  {
    "web-scraper-order": "1666026842-1455",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✳️ Eight-Spoked Asterisk",
    "symbols-href": "https://emojipedia.org/eight-spoked-asterisk/",
    emoji: "✳️",
    emojiName: "✳️ Eight-Spoked Asterisk",
    description:
      "Used in a similar manner to a regular * asterisk character but tends to be shown in a similar vertical alignment to a • bullet point. The eight spoked asterisk has both a ✳︎ text and ✳️ emoji presentation available on most platforms.",
  },
  {
    "web-scraper-order": "1666026845-1457",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "〽️ Part Alternation Mark",
    "symbols-href": "https://emojipedia.org/part-alternation-mark/",
    emoji: "〽️",
    emojiName: "〽️ Part Alternation Mark",
    description:
      "Used in traditional Japanese music such as Noh or Renga, to indicate the start of a song. More specifically, the part alternation mark is displayed where the singer’s part begins.",
  },
  {
    "web-scraper-order": "1666026848-1459",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➿ Double Curly Loop",
    "symbols-href": "https://emojipedia.org/double-curly-loop/",
    emoji: "➿",
    emojiName: "➿ Double Curly Loop",
    description:
      "Two curly loops, which represent a reel-to-reel tape recorder. Used as a symbol for voicemail on many phones.",
  },
  {
    "web-scraper-order": "1666026851-1461",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➰ Curly Loop",
    "symbols-href": "https://emojipedia.org/curly-loop/",
    emoji: "➰",
    emojiName: "➰ Curly Loop",
    description:
      "A curled loop, which is shown in black on most platforms. Previously displayed as a blue ribbon on Samsung devices.",
  },
  {
    "web-scraper-order": "1666026853-1463",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❎ Cross Mark Button",
    "symbols-href": "https://emojipedia.org/cross-mark-button/",
    emoji: "❎",
    emojiName: "❎ Cross Mark Button",
    description:
      "Cross Mark Button was approved as part of Unicode 6.0 in 2010 under the name “Negative Squared Cross Mark” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026855-1465",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❌ Cross Mark",
    "symbols-href": "https://emojipedia.org/cross-mark/",
    emoji: "❌",
    emojiName: "❌ Cross Mark",
    description:
      "A large red cross mark, displayed in the shape of a letter X and similar to a multiplication sign.",
  },
  {
    "web-scraper-order": "1666026857-1467",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✔️ Check Mark",
    "symbols-href": "https://emojipedia.org/check-mark/",
    emoji: "✔️",
    emojiName: "✔️ Check Mark",
    description:
      "A thick check mark / tick displayed on some platforms in a handwritten style. Generally displayed in black. Commonly used in lists to signify completed tasks or verification of a statement of fact.",
  },
  {
    "web-scraper-order": "1666026860-1469",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☑️ Check Box with Check",
    "symbols-href": "https://emojipedia.org/check-box-with-check/",
    emoji: "☑️",
    emojiName: "☑️ Check Box with Check",
    description:
      "A checkbox showing a check mark inside the box. Not to be confused with the similarly named Ballot Box With Ballot emoji.",
  },
  {
    "web-scraper-order": "1666026862-1471",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✅ Check Mark Button",
    "symbols-href": "https://emojipedia.org/check-mark-button/",
    emoji: "✅",
    emojiName: "✅ Check Mark Button",
    description:
      "A check mark that displays with a white outlined appearance. Shows on most platforms with a bright green rounded rectangle or circle surrounding it.",
  },
  {
    "web-scraper-order": "1666026865-1473",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⭕ Hollow Red Circle",
    "symbols-href": "https://emojipedia.org/hollow-red-circle/",
    emoji: "⭕",
    emojiName: "⭕ Hollow Red Circle",
    description:
      "Used as an alternative to a check (tick) in Japan for a something that is correct. The opposite of an X (cross mark) for something wrong.",
  },
  {
    "web-scraper-order": "1666026867-1475",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔰 Japanese Symbol for Beginner",
    "symbols-href": "https://emojipedia.org/japanese-symbol-for-beginner/",
    emoji: "🔰",
    emojiName: "🔰 Japanese Symbol for Beginner",
    description:
      "A yellow and green shield symbol, called a Shoshinsha Mark. Must be displayed by drivers in Japan for one year after they receive their drivers licence.",
  },
  {
    "web-scraper-order": "1666026870-1477",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📛 Name Badge",
    "symbols-href": "https://emojipedia.org/name-badge/",
    emoji: "📛",
    emojiName: "📛 Name Badge",
    description:
      "A name badge, used to identify oneself in a location that others may not know your name, such as a school trip, or a work conference.",
  },
  {
    "web-scraper-order": "1666026872-1479",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔱 Trident Emblem",
    "symbols-href": "https://emojipedia.org/trident-emblem/",
    emoji: "🔱",
    emojiName: "🔱 Trident Emblem",
    description:
      "A trident is a three-pronged spear, that appears similar to a pitchfork. Often held by Greek or Roman Gods in statues.",
  },
  {
    "web-scraper-order": "1666026875-1481",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚜️ Fleur-de-lis",
    "symbols-href": "https://emojipedia.org/fleur-de-lis/",
    emoji: "⚜️",
    emojiName: "⚜️ Fleur-de-lis",
    description:
      "A decorative symbol that appears like a golden flower, but found in all manner of logos, symbols, and patterns. This symbol forms part of the World Scout Emblem, amongst other uses.",
  },
  {
    "web-scraper-order": "1666026878-1483",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♻️ Recycling Symbol",
    "symbols-href": "https://emojipedia.org/recycling-symbol/",
    emoji: "♻️",
    emojiName: "♻️ Recycling Symbol",
    description:
      "The universal recycling symbol, featuring three arrows pointing clockwise in a triangular formation.",
  },
  {
    "web-scraper-order": "1666026881-1485",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚕️ Medical Symbol",
    "symbols-href": "https://emojipedia.org/medical-symbol/",
    emoji: "⚕️",
    emojiName: "⚕️ Medical Symbol",
    description:
      "A symbol displaying of a rod with a snake entwined around the outside in a downward-spiral shape.",
  },
  {
    "web-scraper-order": "1666026884-1487",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💲 Heavy Dollar Sign",
    "symbols-href": "https://emojipedia.org/heavy-dollar-sign/",
    emoji: "💲",
    emojiName: "💲 Heavy Dollar Sign",
    description:
      "Heavy Dollar Sign was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026887-1489",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💱 Currency Exchange",
    "symbols-href": "https://emojipedia.org/currency-exchange/",
    emoji: "💱",
    emojiName: "💱 Currency Exchange",
    description:
      "A symbol for exchanging of two currencies. Most commonly displayed as a dollar symbol, with arrows to and from a yen symbol.",
  },
  {
    "web-scraper-order": "1666026891-1491",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "〰️ Wavy Dash",
    "symbols-href": "https://emojipedia.org/wavy-dash/",
    emoji: "〰️",
    emojiName: "〰️ Wavy Dash",
    description:
      "Just like a regular dash (hyphen), sometimes used in Asian character sets in the same way a – or — is used in latin character sets.",
  },
  {
    "web-scraper-order": "1666026895-1493",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❗ Red Exclamation Mark",
    "symbols-href": "https://emojipedia.org/exclamation-mark/",
    emoji: "❗",
    emojiName: "❗ Red Exclamation Mark",
    description:
      "Red Exclamation Mark was approved as part of Unicode 5.2 in 2009 under the name “Heavy Exclamation Mark Symbol” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026899-1496",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❕ White Exclamation Mark",
    "symbols-href": "https://emojipedia.org/white-exclamation-mark/",
    emoji: "❕",
    emojiName: "❕ White Exclamation Mark",
    description:
      "White Exclamation Mark was approved as part of Unicode 6.0 in 2010 under the name “White Exclamation Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026902-1498",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❔ White Question Mark",
    "symbols-href": "https://emojipedia.org/white-question-mark/",
    emoji: "❔",
    emojiName: "❔ White Question Mark",
    description:
      "White Question Mark was approved as part of Unicode 6.0 in 2010 under the name “White Question Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026906-1500",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❓ Red Question Mark",
    "symbols-href": "https://emojipedia.org/question-mark/",
    emoji: "❓",
    emojiName: "❓ Red Question Mark",
    description:
      "Red Question Mark was approved as part of Unicode 6.0 in 2010 under the name “Black Question Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026909-1502",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⁉️ Exclamation Question Mark",
    "symbols-href": "https://emojipedia.org/exclamation-question-mark/",
    emoji: "⁉️",
    emojiName: "⁉️ Exclamation Question Mark",
    description:
      "Exclamation Question Mark was approved as part of Unicode 3.0 in 1999 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026913-1504",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "‼️ Double Exclamation Mark",
    "symbols-href": "https://emojipedia.org/double-exclamation-mark/",
    emoji: "‼️",
    emojiName: "‼️ Double Exclamation Mark",
    description:
      "Double Exclamation Mark was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026915-1506",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♾️ Infinity",
    "symbols-href": "https://emojipedia.org/infinity/",
    emoji: "♾️",
    emojiName: "♾️ Infinity",
    description: "The symbol for infinity enclosed within a circle or square.",
  },
  {
    "web-scraper-order": "1666026918-1508",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟰 Heavy Equals Sign",
    "symbols-href": "https://emojipedia.org/heavy-equals-sign/",
    emoji: "🟰",
    emojiName: "🟰 Heavy Equals Sign",
    description:
      "An equals sign in the style of the already existing set of mathematical symbols ✖️ Multiply, ➕ Plus, ➖ Minus, and ➗ Divide.",
  },
  {
    "web-scraper-order": "1666026921-1510",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➗ Divide",
    "symbols-href": "https://emojipedia.org/divide/",
    emoji: "➗",
    emojiName: "➗ Divide",
    description:
      "Divide was approved as part of Unicode 6.0 in 2010 under the name “Heavy Division Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026925-1513",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➖ Minus",
    "symbols-href": "https://emojipedia.org/minus/",
    emoji: "➖",
    emojiName: "➖ Minus",
    description:
      "Minus was approved as part of Unicode 6.0 in 2010 under the name “Heavy Minus Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026929-1515",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➕ Plus",
    "symbols-href": "https://emojipedia.org/plus/",
    emoji: "➕",
    emojiName: "➕ Plus",
    description:
      "Plus was approved as part of Unicode 6.0 in 2010 under the name “Heavy Plus Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026933-1518",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✖️ Multiply",
    "symbols-href": "https://emojipedia.org/multiply/",
    emoji: "✖️",
    emojiName: "✖️ Multiply",
    description:
      "Multiply was approved as part of Unicode 1.1 in 1993 under the name “Heavy Multiplication X” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026936-1520",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♂️ Male Sign",
    "symbols-href": "https://emojipedia.org/male-sign/",
    emoji: "♂️",
    emojiName: "♂️ Male Sign",
    description:
      "A circle shown with a diagonal arrow pointing out the top-right, used as a representation for men.",
  },
  {
    "web-scraper-order": "1666026938-1521",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♀️ Female Sign",
    "symbols-href": "https://emojipedia.org/female-sign/",
    emoji: "♀️",
    emojiName: "♀️ Female Sign",
    description:
      "A circle shown with a crossed vertical line beneath it, used as a representation for women. Often used on International Women's Day.",
  },
  {
    "web-scraper-order": "1666026942-1524",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📴 Mobile Phone Off",
    "symbols-href": "https://emojipedia.org/mobile-phone-off/",
    emoji: "📴",
    emojiName: "📴 Mobile Phone Off",
    description:
      "A sign indicating that mobile phones should be turned off. Used in situations such as a cinema or live performance.",
  },
  {
    "web-scraper-order": "1666026946-1527",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📳 Vibration Mode",
    "symbols-href": "https://emojipedia.org/vibration-mode/",
    emoji: "📳",
    emojiName: "📳 Vibration Mode",
    description:
      "An icon representing vibration mode on a mobile phone, indicating that a phone should be switched to silent and/or vibrate mode.",
  },
  {
    "web-scraper-order": "1666026950-1529",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📶 Antenna Bars",
    "symbols-href": "https://emojipedia.org/antenna-bars/",
    emoji: "📶",
    emojiName: "📶 Antenna Bars",
    description:
      "Bars increasing in height, showing the strength of the mobile (cellular) phone signal. More bars signifies better reception.",
  },
  {
    "web-scraper-order": "1666026953-1531",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔆 Bright Button",
    "symbols-href": "https://emojipedia.org/bright-button/",
    emoji: "🔆",
    emojiName: "🔆 Bright Button",
    description:
      "An icon of a outlined sun, used when increasing the brightness of a screen. Appears larger than the Low Brightness Symbol.",
  },
  {
    "web-scraper-order": "1666026956-1533",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔅 Dim Button",
    "symbols-href": "https://emojipedia.org/dim-button/",
    emoji: "🔅",
    emojiName: "🔅 Dim Button",
    description:
      "An icon of a outlined sun, used when decreasing the brightness of a screen. Appears smaller than the High Brightness Symbol.",
  },
  {
    "web-scraper-order": "1666026959-1535",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎦 Cinema",
    "symbols-href": "https://emojipedia.org/cinema/",
    emoji: "🎦",
    emojiName: "🎦 Cinema",
    description:
      "An emoji representing the cinema: a large screen showing the latest movies, available to the public. Displayed by most platforms as a film projector symbol, and previously by Google and Microsoft as a cinema screen with curtains.",
  },
  {
    "web-scraper-order": "1666026963-1538",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏏️ Eject Button",
    "symbols-href": "https://emojipedia.org/eject-button/",
    emoji: "⏏️",
    emojiName: "⏏️ Eject Button",
    description:
      "An eject symbol, displayed as an upward-pointing triangle above a horiztonal bar. May be used as a physical button or an icon in a user interface. Represents the action of ejecting physical media such as a floppy disk, videocasette or DVD on a computer or media player.",
  },
  {
    "web-scraper-order": "1666026966-1540",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏺️ Record Button",
    "symbols-href": "https://emojipedia.org/record-button/",
    emoji: "⏺️",
    emojiName: "⏺️ Record Button",
    description: "A record icon, displayed as a circle.",
  },
  {
    "web-scraper-order": "1666026970-1542",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏹️ Stop Button",
    "symbols-href": "https://emojipedia.org/stop-button/",
    emoji: "⏹️",
    emojiName: "⏹️ Stop Button",
    description: "A stop icon, displayed as a square.",
  },
  {
    "web-scraper-order": "1666026972-1544",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏸️ Pause Button",
    "symbols-href": "https://emojipedia.org/pause-button/",
    emoji: "⏸️",
    emojiName: "⏸️ Pause Button",
    description: "A pause icon, displayed as two vertical bars.",
  },
  {
    "web-scraper-order": "1666026991-1547",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏬ Fast Down Button",
    "symbols-href": "https://emojipedia.org/fast-down-button/",
    emoji: "⏬",
    emojiName: "⏬ Fast Down Button",
    description:
      "Two triangles pointing down. Similar to rewind icon, rotated 90° counter-clockwise.",
  },
  {
    "web-scraper-order": "1666026994-1550",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔽 Downwards Button",
    "symbols-href": "https://emojipedia.org/downwards-button/",
    emoji: "🔽",
    emojiName: "🔽 Downwards Button",
    description:
      "A triangle-shaped arrow, pointing down. Styled similarly to the left and right pointing triangles and colored as either gray or blue, but shown in orange on Android.",
  },
  {
    "web-scraper-order": "1666026997-1553",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏫ Fast Up Button",
    "symbols-href": "https://emojipedia.org/fast-up-button/",
    emoji: "⏫",
    emojiName: "⏫ Fast Up Button",
    description:
      "Two triangles pointing up. Similar to rewind icon, rotated 90° clockwise.",
  },
  {
    "web-scraper-order": "1666026999-1556",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔼 Upwards Button",
    "symbols-href": "https://emojipedia.org/upwards-button/",
    emoji: "🔼",
    emojiName: "🔼 Upwards Button",
    description:
      "A triangle-shaped arrow, pointing up. Styled similarly to the left and right triangles and colored as either gray or blue, but shown in orange on Android.",
  },
  {
    "web-scraper-order": "1666027003-1559",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏮️ Last Track Button",
    "symbols-href": "https://emojipedia.org/last-track-button/",
    emoji: "⏮️",
    emojiName: "⏮️ Last Track Button",
    description:
      "A symbol used in media players to indicate skipping to the first or previous track (or scene). Shown as a vertical bar followed by two triangles pointing left.",
  },
  {
    "web-scraper-order": "1666027006-1562",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏪ Fast Reverse Button",
    "symbols-href": "https://emojipedia.org/fast-reverse-button/",
    emoji: "⏪",
    emojiName: "⏪ Fast Reverse Button",
    description:
      "Two triangles pointing to the left. Most commonly used as a symbol for rewinding media such as video tapes, CDs, or digital audio and video.",
  },
  {
    "web-scraper-order": "1666027009-1565",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◀️ Reverse Button",
    "symbols-href": "https://emojipedia.org/reverse-button/",
    emoji: "◀️",
    emojiName: "◀️ Reverse Button",
    description: "A triangle-shaped arrow, pointing left.",
  },
  {
    "web-scraper-order": "1666027012-1569",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏯️ Play or Pause Button",
    "symbols-href": "https://emojipedia.org/play-or-pause-button/",
    emoji: "⏯️",
    emojiName: "⏯️ Play or Pause Button",
    description:
      "A play-pause icon, showing a right-pointing triangle (play) next to a double vertical bar (pause).",
  },
  {
    "web-scraper-order": "1666027015-1572",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏭️ Next Track Button",
    "symbols-href": "https://emojipedia.org/next-track-button/",
    emoji: "⏭️",
    emojiName: "⏭️ Next Track Button",
    description:
      "A symbol used in media players to indicate skipping to the next track (or scene). Shown as two triangles pointing right followed by a vertical bar.",
  },
  {
    "web-scraper-order": "1666027018-1575",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏩ Fast-Forward Button",
    "symbols-href": "https://emojipedia.org/fast-forward-button/",
    emoji: "⏩",
    emojiName: "⏩ Fast-Forward Button",
    description:
      "Two triangles pointing to the right. Most commonly used as a symbol for fast forwarding media such as video tapes, CDs, or digital audio and video.",
  },
  {
    "web-scraper-order": "1666027021-1578",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▶️ Play Button",
    "symbols-href": "https://emojipedia.org/play-button/",
    emoji: "▶️",
    emojiName: "▶️ Play Button",
    description:
      "A triangle-shaped arrow, pointing right. Commonly used as a symbol for play.",
  },
  {
    "web-scraper-order": "1666027024-1581",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔂 Repeat Single Button",
    "symbols-href": "https://emojipedia.org/repeat-single-button/",
    emoji: "🔂",
    emojiName: "🔂 Repeat Single Button",
    description:
      "Arrows pointing in a clockwise direction, with a number 1 badge in the lower corner.  Used in music player applications to loop a track or album once.",
  },
  {
    "web-scraper-order": "1666027026-1584",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔁 Repeat Button",
    "symbols-href": "https://emojipedia.org/repeat-button/",
    emoji: "🔁",
    emojiName: "🔁 Repeat Button",
    description:
      "Circular arrows pointing in a clockwise direction. Used in music player applications to loop a track or album continuously. Commonly used to repesent a retweet on Twitter.",
  },
  {
    "web-scraper-order": "1666027028-1587",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔀 Shuffle Tracks Button",
    "symbols-href": "https://emojipedia.org/shuffle-tracks-button/",
    emoji: "🔀",
    emojiName: "🔀 Shuffle Tracks Button",
    description:
      "Two arrows pointing right while crossing over one another. Used to indicate putting music on shuffle: randomizing the order of tracks in the upcoming playlist. May also be used to indicate two items switching places.",
  },
  {
    "web-scraper-order": "1666027031-1590",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⛎ Ophiuchus",
    "symbols-href": "https://emojipedia.org/ophiuchus/",
    emoji: "⛎",
    emojiName: "⛎ Ophiuchus",
    description:
      "Ophiuchus is used by some as a 13th sign in the Zodiac. The symbol for ophiuchus appears a U shape with a wavy line through it.",
  },
  {
    "web-scraper-order": "1666027034-1593",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♓ Pisces",
    "symbols-href": "https://emojipedia.org/pisces/",
    emoji: "♓",
    emojiName: "♓ Pisces",
    description:
      "The Pisces astrological sign in the Zodiac. This Zodiac Symbol represents a Fish.",
  },
  {
    "web-scraper-order": "1666027036-1596",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♒ Aquarius",
    "symbols-href": "https://emojipedia.org/aquarius/",
    emoji: "♒",
    emojiName: "♒ Aquarius",
    description:
      "The Aquarius astrological sign in the Zodiac. This Zodiac Symbol represents a Water-bearer.",
  },
  {
    "web-scraper-order": "1666027039-1599",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♑ Capricorn",
    "symbols-href": "https://emojipedia.org/capricorn/",
    emoji: "♑",
    emojiName: "♑ Capricorn",
    description:
      "The Capricorn astrological sign in the Zodiac. This Zodiac Symbol represents a Goat.",
  },
  {
    "web-scraper-order": "1666027042-1602",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♐ Sagittarius",
    "symbols-href": "https://emojipedia.org/sagittarius/",
    emoji: "♐",
    emojiName: "♐ Sagittarius",
    description:
      "The Sagittarius astrological sign in the Zodiac. This Zodiac Symbol represents an Archer.",
  },
  {
    "web-scraper-order": "1666027044-1605",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♏ Scorpio",
    "symbols-href": "https://emojipedia.org/scorpio/",
    emoji: "♏",
    emojiName: "♏ Scorpio",
    description:
      "The Scorpius astrological sign in the Zodiac. This Zodiac Symbol represents a Scorpion.",
  },
  {
    "web-scraper-order": "1666027047-1608",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♎ Libra",
    "symbols-href": "https://emojipedia.org/libra/",
    emoji: "♎",
    emojiName: "♎ Libra",
    description:
      "The Libra astrological sign in the Zodiac. This Zodiac Symbol represents weighing scales.",
  },
  {
    "web-scraper-order": "1666027049-1610",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♍ Virgo",
    "symbols-href": "https://emojipedia.org/virgo/",
    emoji: "♍",
    emojiName: "♍ Virgo",
    description:
      "The Virgo astrological sign in the Zodiac. This Zodiac Symbol represents a Maiden.",
  },
  {
    "web-scraper-order": "1666027051-1613",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♌ Leo",
    "symbols-href": "https://emojipedia.org/leo/",
    emoji: "♌",
    emojiName: "♌ Leo",
    description:
      "The Leo astrological sign in the Zodiac. This Zodiac Symbol represents a Lion.",
  },
  {
    "web-scraper-order": "1666027054-1616",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♋ Cancer",
    "symbols-href": "https://emojipedia.org/cancer/",
    emoji: "♋",
    emojiName: "♋ Cancer",
    description:
      "The Cancer astrological sign in the Zodiac. This Zodiac Symbol represents a Crab.",
  },
  {
    "web-scraper-order": "1666027057-1619",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♊ Gemini",
    "symbols-href": "https://emojipedia.org/gemini/",
    emoji: "♊",
    emojiName: "♊ Gemini",
    description:
      "The Gemini astrological sign in the Zodiac. This Zodiac Symbol represents Twins.",
  },
  {
    "web-scraper-order": "1666027059-1622",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♉ Taurus",
    "symbols-href": "https://emojipedia.org/taurus/",
    emoji: "♉",
    emojiName: "♉ Taurus",
    description:
      "The Taurus astrological sign in the Zodiac. This Zodiac Symbol represents a Bull.",
  },
  {
    "web-scraper-order": "1666027061-1625",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♈ Aries",
    "symbols-href": "https://emojipedia.org/aries/",
    emoji: "♈",
    emojiName: "♈ Aries",
    description:
      "The Aries astrological sign in the Zodiac. This Zodiac Symbol represents a Ram.",
  },
  {
    "web-scraper-order": "1666027064-1628",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔯 Dotted Six-Pointed Star",
    "symbols-href": "https://emojipedia.org/dotted-six-pointed-star/",
    emoji: "🔯",
    emojiName: "🔯 Dotted Six-Pointed Star",
    description:
      "A star with six points, and a dot in the center. Similar to the Star of David emoji.",
  },
  {
    "web-scraper-order": "1666027066-1631",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕎 Menorah",
    "symbols-href": "https://emojipedia.org/menorah/",
    emoji: "🕎",
    emojiName: "🕎 Menorah",
    description:
      "A menorah showing nine lit candles, used on the Jewish holiday of Hanukkah.",
  },
  {
    "web-scraper-order": "1666027068-1634",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☮️ Peace Symbol",
    "symbols-href": "https://emojipedia.org/peace-symbol/",
    emoji: "☮️",
    emojiName: "☮️ Peace Symbol",
    description:
      "A circular symbol, commonly used as a representation of peace. Alternatives include the Victory Hand, or the Dove of Peace.",
  },
  {
    "web-scraper-order": "1666027071-1637",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☪️ Star and Crescent",
    "symbols-href": "https://emojipedia.org/star-and-crescent/",
    emoji: "☪️",
    emojiName: "☪️ Star and Crescent",
    description:
      "The crescent moon and star is a symbol often associated with the religion of Islam. This symbol can be found on the flags of many countries, such as Algeria, Azerbaijan, Malaysia, Pakistan and Turkey.",
  },
  {
    "web-scraper-order": "1666027074-1640",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☦️ Orthodox Cross",
    "symbols-href": "https://emojipedia.org/orthodox-cross/",
    emoji: "☦️",
    emojiName: "☦️ Orthodox Cross",
    description:
      "Orthodox Cross was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027076-1643",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✝️ Latin Cross",
    "symbols-href": "https://emojipedia.org/latin-cross/",
    emoji: "✝️",
    emojiName: "✝️ Latin Cross",
    description:
      "A latin cross, otherwise known as a Christian cross. This cross symbol is often used as a symbol of Christianity. Similar in appearance to the Orthodox cross.",
  },
  {
    "web-scraper-order": "1666027078-1646",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☯️ Yin Yang",
    "symbols-href": "https://emojipedia.org/yin-yang/",
    emoji: "☯️",
    emojiName: "☯️ Yin Yang",
    description:
      "Yin Yang was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027081-1649",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☸️ Wheel of Dharma",
    "symbols-href": "https://emojipedia.org/wheel-of-dharma/",
    emoji: "☸️",
    emojiName: "☸️ Wheel of Dharma",
    description:
      "A symbol often used in relation to the Indian religions of Hinduism, Buddhism, Sikhism and Jainism.",
  },
  {
    "web-scraper-order": "1666027083-1652",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✡️ Star of David",
    "symbols-href": "https://emojipedia.org/star-of-david/",
    emoji: "✡️",
    emojiName: "✡️ Star of David",
    description:
      "A symbol often used in relation to the religion of Judaism. Not to be confused with the Six Pointed Star With Middle Dot emoji.",
  },
  {
    "web-scraper-order": "1666027085-1655",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕉️ Om",
    "symbols-href": "https://emojipedia.org/om/",
    emoji: "🕉️",
    emojiName: "🕉️ Om",
    description:
      "A symbol often used in relation to the religions of Hinduism, Buddhism, Sikhism and Jainism.",
  },
  {
    "web-scraper-order": "1666027089-1657",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚛️ Atom Symbol",
    "symbols-href": "https://emojipedia.org/atom-symbol/",
    emoji: "⚛️",
    emojiName: "⚛️ Atom Symbol",
    description:
      "Atom Symbol was approved as part of Unicode 4.1 in 2005 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027091-1660",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛐 Place of Worship",
    "symbols-href": "https://emojipedia.org/place-of-worship/",
    emoji: "🛐",
    emojiName: "🛐 Place of Worship",
    description:
      "A building used for worship by people of any faith or religion. Examples include a church, mosque, or synagogue. A person is shown on their knees praying, in this symbol.",
  },
  {
    "web-scraper-order": "1666027094-1662",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔝 Top Arrow",
    "symbols-href": "https://emojipedia.org/top-arrow/",
    emoji: "🔝",
    emojiName: "🔝 Top Arrow",
    description: 'The word "top" with an arrow pointing up above it.',
  },
  {
    "web-scraper-order": "1666027096-1665",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔜 Soon Arrow",
    "symbols-href": "https://emojipedia.org/soon-arrow/",
    emoji: "🔜",
    emojiName: "🔜 Soon Arrow",
    description:
      'The word "soon" with an arrow above it, pointing to the right.',
  },
  {
    "web-scraper-order": "1666027099-1669",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔛 On! Arrow",
    "symbols-href": "https://emojipedia.org/on-arrow/",
    emoji: "🔛",
    emojiName: "🔛 On! Arrow",
    description:
      "On! Arrow was approved as part of Unicode 6.0 in 2010 under the name “On with Exclamation Mark with Left Right Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027101-1671",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔚 End Arrow",
    "symbols-href": "https://emojipedia.org/end-arrow/",
    emoji: "🔚",
    emojiName: "🔚 End Arrow",
    description:
      "End Arrow was approved as part of Unicode 6.0 in 2010 under the name “End with Leftwards Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027104-1674",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔙 Back Arrow",
    "symbols-href": "https://emojipedia.org/back-arrow/",
    emoji: "🔙",
    emojiName: "🔙 Back Arrow",
    description:
      "Back Arrow was approved as part of Unicode 6.0 in 2010 under the name “Back with Leftwards Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027106-1677",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔄 Counterclockwise Arrows Button",
    "symbols-href": "https://emojipedia.org/counterclockwise-arrows-button/",
    emoji: "🔄",
    emojiName: "🔄 Counterclockwise Arrows Button",
    description:
      "Two arrows forming a circle, pointing in an anticlockwise direction. Similar to symbols sometimes used for refresh or rotate. May also be used to indicate a task is in progress.",
  },
  {
    "web-scraper-order": "1666027109-1681",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔃 Clockwise Vertical Arrows",
    "symbols-href": "https://emojipedia.org/clockwise-vertical-arrows/",
    emoji: "🔃",
    emojiName: "🔃 Clockwise Vertical Arrows",
    description:
      "Clockwise Vertical Arrows was approved as part of Unicode 6.0 in 2010 under the name “Clockwise Downwards and Upwards Open Circle Arrows” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027111-1683",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⤵️ Right Arrow Curving Down",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-down/",
    emoji: "⤵️",
    emojiName: "⤵️ Right Arrow Curving Down",
    description: "A curved arrow pointing down.",
  },
  {
    "web-scraper-order": "1666027115-1686",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⤴️ Right Arrow Curving Up",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-up/",
    emoji: "⤴️",
    emojiName: "⤴️ Right Arrow Curving Up",
    description: "A curved arrow pointing up.",
  },
  {
    "web-scraper-order": "1666027118-1690",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↪️ Left Arrow Curving Right",
    "symbols-href": "https://emojipedia.org/left-arrow-curving-right/",
    emoji: "↪️",
    emojiName: "↪️ Left Arrow Curving Right",
    description:
      "An arrow pointing to the right, with a curved hook at the other end. Similar in appearance to a sideways U Turn symbol, or a forward icon in an email application.",
  },
  {
    "web-scraper-order": "1666027121-1693",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↩️ Right Arrow Curving Left",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-left/",
    emoji: "↩️",
    emojiName: "↩️ Right Arrow Curving Left",
    description:
      "An arrow pointing to the left, with a curved hook at the other end. Similar in appearance to a sideways U Turn symbol, or a reply icon in an email application.",
  },
  {
    "web-scraper-order": "1666027123-1696",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↔️ Left-Right Arrow",
    "symbols-href": "https://emojipedia.org/left-right-arrow/",
    emoji: "↔️",
    emojiName: "↔️ Left-Right Arrow",
    description:
      "A horizontal line with arrowheads on both ends, pointing left and right.",
  },
  {
    "web-scraper-order": "1666027126-1699",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↕️ Up-Down Arrow",
    "symbols-href": "https://emojipedia.org/up-down-arrow/",
    emoji: "↕️",
    emojiName: "↕️ Up-Down Arrow",
    description:
      "A vertical line with arrowheads on both ends, pointing up and down.",
  },
  {
    "web-scraper-order": "1666027129-1701",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↖️ Up-Left Arrow",
    "symbols-href": "https://emojipedia.org/up-left-arrow/",
    emoji: "↖️",
    emojiName: "↖️ Up-Left Arrow",
    description:
      "An arrow pointing diagonally in an up-left, or north-west direction.",
  },
  {
    "web-scraper-order": "1666027131-1704",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬅️ Left Arrow",
    "symbols-href": "https://emojipedia.org/left-arrow/",
    emoji: "⬅️",
    emojiName: "⬅️ Left Arrow",
    description: "An arrow, pointing left.",
  },
  {
    "web-scraper-order": "1666027134-1706",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↙️ Down-Left Arrow",
    "symbols-href": "https://emojipedia.org/down-left-arrow/",
    emoji: "↙️",
    emojiName: "↙️ Down-Left Arrow",
    description:
      "An arrow pointing diagonally in an down-left, or south-west direction.",
  },
  {
    "web-scraper-order": "1666027136-1709",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬇️ Down Arrow",
    "symbols-href": "https://emojipedia.org/down-arrow/",
    emoji: "⬇️",
    emojiName: "⬇️ Down Arrow",
    description: "An arrow, pointing down.",
  },
  {
    "web-scraper-order": "1666027140-1712",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↘️ Down-Right Arrow",
    "symbols-href": "https://emojipedia.org/down-right-arrow/",
    emoji: "↘️",
    emojiName: "↘️ Down-Right Arrow",
    description:
      "An arrow pointing diagonally in an down-right, or south-east direction.",
  },
  {
    "web-scraper-order": "1666027142-1715",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➡️ Right Arrow",
    "symbols-href": "https://emojipedia.org/right-arrow/",
    emoji: "➡️",
    emojiName: "➡️ Right Arrow",
    description: "An arrow, pointing right.",
  },
  {
    "web-scraper-order": "1666027145-1717",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↗️ Up-Right Arrow",
    "symbols-href": "https://emojipedia.org/up-right-arrow/",
    emoji: "↗️",
    emojiName: "↗️ Up-Right Arrow",
    description:
      "An arrow pointing diagonally in an up-right, or north-east direction.",
  },
  {
    "web-scraper-order": "1666027147-1720",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬆️ Up Arrow",
    "symbols-href": "https://emojipedia.org/up-arrow/",
    emoji: "⬆️",
    emojiName: "⬆️ Up Arrow",
    description: "An arrow, pointing up.",
  },
  {
    "web-scraper-order": "1666027150-1722",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☣️ Biohazard",
    "symbols-href": "https://emojipedia.org/biohazard/",
    emoji: "☣️",
    emojiName: "☣️ Biohazard",
    description:
      "Biohazard was approved as part of Unicode 1.1 in 1993 under the name “Biohazard Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027152-1725",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☢️ Radioactive",
    "symbols-href": "https://emojipedia.org/radioactive/",
    emoji: "☢️",
    emojiName: "☢️ Radioactive",
    description:
      "A hazard symbol for radiation or radioactivity. May appear similar to a three-pronged fan at small sizes.",
  },
  {
    "web-scraper-order": "1666027155-1727",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔞 No One Under Eighteen",
    "symbols-href": "https://emojipedia.org/no-one-under-eighteen/",
    emoji: "🔞",
    emojiName: "🔞 No One Under Eighteen",
    description:
      "The number eighteen with a red stroke through it, indicating a location where a person must be aged 18 or above to enter. Often used online to indicate adult or NSFW content.",
  },
  {
    "web-scraper-order": "1666027157-1730",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📵 No Mobile Phones",
    "symbols-href": "https://emojipedia.org/no-mobile-phones/",
    emoji: "📵",
    emojiName: "📵 No Mobile Phones",
    description:
      "A mobile phone with a red stroke through it, indicating that mobile phones should not be present. Often seen in restricted areas, such as Customs or Passport Control.",
  },
  {
    "web-scraper-order": "1666027159-1731",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚷 No Pedestrians",
    "symbols-href": "https://emojipedia.org/no-pedestrians/",
    emoji: "🚷",
    emojiName: "🚷 No Pedestrians",
    description:
      "A pedestrian symbol with a red stroke through it, indicating that pedestrians are prohibited from this location.",
  },
  {
    "web-scraper-order": "1666027163-1735",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚱 Non-Potable Water",
    "symbols-href": "https://emojipedia.org/non-potable-water/",
    emoji: "🚱",
    emojiName: "🚱 Non-Potable Water",
    description:
      "A water tap with a red stroke through it, indicating that water is not safe for drinking (non-potable).",
  },
  {
    "web-scraper-order": "1666027166-1737",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚯 No Littering",
    "symbols-href": "https://emojipedia.org/no-littering/",
    emoji: "🚯",
    emojiName: "🚯 No Littering",
    description:
      "A person dropping litter (rubbish, trash) with a red stroke through it, indicating that littering is prohibited in this area.",
  },
  {
    "web-scraper-order": "1666027168-1740",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚭 No Smoking",
    "symbols-href": "https://emojipedia.org/no-smoking/",
    emoji: "🚭",
    emojiName: "🚭 No Smoking",
    description:
      "No Smoking was approved as part of Unicode 6.0 in 2010 under the name “No Smoking Symbol” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027171-1742",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚳 No Bicycles",
    "symbols-href": "https://emojipedia.org/no-bicycles/",
    emoji: "🚳",
    emojiName: "🚳 No Bicycles",
    description:
      "A bicycle with a red stroke through it, indicating that bikes are prohibited from this location.",
  },
  {
    "web-scraper-order": "1666027173-1744",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚫 Prohibited",
    "symbols-href": "https://emojipedia.org/prohibited/",
    emoji: "🚫",
    emojiName: "🚫 Prohibited",
    description:
      "A red circle with a diagonal line through the middle, from top-left to bottom right, used to indicate that something is not permitted",
  },
  {
    "web-scraper-order": "1666027176-1746",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⛔ No Entry",
    "symbols-href": "https://emojipedia.org/no-entry/",
    emoji: "⛔",
    emojiName: "⛔ No Entry",
    description:
      "No Entry was approved as part of Unicode 5.2 in 2009 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027181-1749",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚸 Children Crossing",
    "symbols-href": "https://emojipedia.org/children-crossing/",
    emoji: "🚸",
    emojiName: "🚸 Children Crossing",
    description:
      "A crossing sign for children, usually positioned near schools or other areas that drivers should be cautious of young children in the area.",
  },
  {
    "web-scraper-order": "1666027183-1750",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚠️ Warning",
    "symbols-href": "https://emojipedia.org/warning/",
    emoji: "⚠️",
    emojiName: "⚠️ Warning",
    description:
      "A triangle with an exclamation mark inside, used as a warning or alert.",
  },
  {
    "web-scraper-order": "1666027187-1753",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚾 Water Closet",
    "symbols-href": "https://emojipedia.org/water-closet/",
    emoji: "🚾",
    emojiName: "🚾 Water Closet",
    description:
      "A water closet is a name used for public toilet, bathroom or restroom used in some countries. Typically abbreviated to the letters WC, this may be found on signage in public buildings, as an alternative to the restroom symbol.",
  },
  {
    "web-scraper-order": "1666027190-1755",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚼 Baby Symbol",
    "symbols-href": "https://emojipedia.org/baby-symbol/",
    emoji: "🚼",
    emojiName: "🚼 Baby Symbol",
    description:
      "The symbol for a baby, usually used to indicate a room that is suitable to change a baby in. Often located in or near public restrooms.",
  },
  {
    "web-scraper-order": "1666027192-1759",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚻 Restroom",
    "symbols-href": "https://emojipedia.org/restroom/",
    emoji: "🚻",
    emojiName: "🚻 Restroom",
    description:
      "A restroom symbol, depicting a iconography of a man and woman. Used to indicate the location of public bathrooms / toilets / restrooms.",
  },
  {
    "web-scraper-order": "1666027196-1761",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚺 Women’s Room",
    "symbols-href": "https://emojipedia.org/womens-room/",
    emoji: "🚺",
    emojiName: "🚺 Women’s Room",
    description:
      "A stick-figure icon of a woman, generally used to indicate a female restroom. The male equivalent is the Mens Symbol emoji.",
  },
  {
    "web-scraper-order": "1666027200-1763",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚹 Men’s Room",
    "symbols-href": "https://emojipedia.org/mens-room/",
    emoji: "🚹",
    emojiName: "🚹 Men’s Room",
    description:
      "A stick-figure icon of a man, generally used to indicate a male restroom. The female equivalent is the Womens Symbol emoji.",
  },
  {
    "web-scraper-order": "1666027202-1764",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♿ Wheelchair Symbol",
    "symbols-href": "https://emojipedia.org/wheelchair-symbol/",
    emoji: "♿",
    emojiName: "♿ Wheelchair Symbol",
    description:
      "The international symbol of access, used to denote a facility which has been designed with accessibility or people in wheelchairs in mind. Appears as a blue sign, with a white graphic of a person sitting in a wheelchair.",
  },
  {
    "web-scraper-order": "1666027206-1767",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚰 Potable Water",
    "symbols-href": "https://emojipedia.org/potable-water/",
    emoji: "🚰",
    emojiName: "🚰 Potable Water",
    description:
      "A symbol for potable (drinkable) water, usually shown with a faucet filling a drinking glass. Commonly used for various content concerning water, drinking, thirst, and dripping.",
  },
  {
    "web-scraper-order": "1666027209-1769",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚮 Litter in Bin Sign",
    "symbols-href": "https://emojipedia.org/litter-in-bin-sign/",
    emoji: "🚮",
    emojiName: "🚮 Litter in Bin Sign",
    description:
      "A symbol showing a person putting litter (rubbish) in the trash (rubbish bin). A more positive version of the Do Not Litter Symbol.",
  },
  {
    "web-scraper-order": "1666027212-1771",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🏧 ATM Sign",
    "symbols-href": "https://emojipedia.org/atm-sign/",
    emoji: "🏧",
    emojiName: "🏧 ATM Sign",
    description:
      "ATM Sign was approved as part of Unicode 6.0 in 2010 under the name “Automated Teller Machine” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027214-1774",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛗 Elevator",
    "symbols-href": "https://emojipedia.org/elevator/",
    emoji: "🛗",
    emojiName: "🛗 Elevator",
    description:
      "A symbol showing two or three people standing in a square with up and down arrows above them. Most platforms feature a simple blue and white design.",
  },
  {
    "web-scraper-order": "1666027217-1776",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💹 Chart Increasing with Yen",
    "symbols-href": "https://emojipedia.org/chart-increasing-with-yen/",
    emoji: "💹",
    emojiName: "💹 Chart Increasing with Yen",
    description: "A graph showing the value of the Japanese Yen rising.",
  },
  {
    "web-scraper-order": "1666027221-1780",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎶 Musical Notes",
    "symbols-href": "https://emojipedia.org/musical-notes/",
    emoji: "🎶",
    emojiName: "🎶 Musical Notes",
    description:
      "Three eighth notes (quavers in British English), used to represent music or singing. Sometimes inserted next to quoted lyrics, to make it clear that they are part of a song.",
  },
  {
    "web-scraper-order": "1666027223-1781",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎵 Musical Note",
    "symbols-href": "https://emojipedia.org/musical-note/",
    emoji: "🎵",
    emojiName: "🎵 Musical Note",
    description:
      "A music note emoji, which can denote song lyrics, or other music related topics.",
  },
  {
    "web-scraper-order": "1666027226-1785",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔕 Bell with Slash",
    "symbols-href": "https://emojipedia.org/bell-with-slash/",
    emoji: "🔕",
    emojiName: "🔕 Bell with Slash",
    description:
      "A gold or yellow bell with a red line through it, which is commonly used on mobile phones as an icon for the silencing of notifications or ringing sounds. A mute, or silent mode.",
  },
  {
    "web-scraper-order": "1666027229-1787",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔔 Bell",
    "symbols-href": "https://emojipedia.org/bell/",
    emoji: "🔔",
    emojiName: "🔔 Bell",
    description:
      "A gold or yellow bell, which is commonly used on mobile phones as an icon for notifications or ringing sounds.",
  },
  {
    "web-scraper-order": "1666027231-1789",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📯 Postal Horn",
    "symbols-href": "https://emojipedia.org/postal-horn/",
    emoji: "📯",
    emojiName: "📯 Postal Horn",
    description:
      "A postal horn (post horn). Depicted as a coiled, valveless, brass horn, like a bugle or trumpet, with two red tassels. Sometimes used to mark announcements as well as for various content concerning brass instruments, music, or mail.",
  },
  {
    "web-scraper-order": "1666027233-1791",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📣 Megaphone",
    "symbols-href": "https://emojipedia.org/megaphone/",
    emoji: "📣",
    emojiName: "📣 Megaphone",
    description:
      "Megaphone was approved as part of Unicode 6.0 in 2010 under the name “Cheering Megaphone” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027236-1793",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📢 Loudspeaker",
    "symbols-href": "https://emojipedia.org/loudspeaker/",
    emoji: "📢",
    emojiName: "📢 Loudspeaker",
    description:
      "A loudspeaker used to make announcements in public areas such as schools, or sporting grounds.",
  },
  {
    "web-scraper-order": "1666027238-1796",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔊 Speaker High Volume",
    "symbols-href": "https://emojipedia.org/speaker-high-volume/",
    emoji: "🔊",
    emojiName: "🔊 Speaker High Volume",
    description:
      "A speaker cone displayed with three sound waves, generally used as an icon to indicate the increasing of volume on a phone or computer.",
  },
  {
    "web-scraper-order": "1666027241-1798",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔉 Speaker Medium Volume",
    "symbols-href": "https://emojipedia.org/speaker-medium-volume/",
    emoji: "🔉",
    emojiName: "🔉 Speaker Medium Volume",
    description:
      "A speaker cone displayed with one sound wave, generally used as an icon to indicate the decreasing of volume on a phone or computer.",
  },
  {
    "web-scraper-order": "1666027244-1800",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔈 Speaker Low Volume",
    "symbols-href": "https://emojipedia.org/speaker-low-volume/",
    emoji: "🔈",
    emojiName: "🔈 Speaker Low Volume",
    description: "A speaker cone displayed without any sound waves.",
  },
  {
    "web-scraper-order": "1666027246-1803",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔇 Muted Speaker",
    "symbols-href": "https://emojipedia.org/muted-speaker/",
    emoji: "🔇",
    emojiName: "🔇 Muted Speaker",
    description:
      "A speaker with a red line through it, indicating muted volume or silencing of audio.",
  },
  {
    "web-scraper-order": "1666027249-1806",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎴 Flower Playing Cards",
    "symbols-href": "https://emojipedia.org/flower-playing-cards/",
    emoji: "🎴",
    emojiName: "🎴 Flower Playing Cards",
    description:
      "A type of cards known as hanafuda cards in Japan which are used for a range of different games that require associating pictures (there are no numbers on the cards).",
  },
  {
    "web-scraper-order": "1666027252-1809",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🀄 Mahjong Red Dragon",
    "symbols-href": "https://emojipedia.org/mahjong-red-dragon/",
    emoji: "🀄",
    emojiName: "🀄 Mahjong Red Dragon",
    description:
      "The red dragon tile in the game of Japanese Mahjong. White, with red 中 character printed on it.",
  },
  {
    "web-scraper-order": "1666027255-1810",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🃏 Joker",
    "symbols-href": "https://emojipedia.org/joker/",
    emoji: "🃏",
    emojiName: "🃏 Joker",
    description:
      "The joker in a deck of cards, usually appearing like a court jester.",
  },
  {
    "web-scraper-order": "1666027257-1813",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♣️ Club Suit",
    "symbols-href": "https://emojipedia.org/club-suit/",
    emoji: "♣️",
    emojiName: "♣️ Club Suit",
    description:
      "A club symbol emoji, which is used in card games for the clubs suit.",
  },
  {
    "web-scraper-order": "1666027260-1816",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♦️ Diamond Suit",
    "symbols-href": "https://emojipedia.org/diamond-suit/",
    emoji: "♦️",
    emojiName: "♦️ Diamond Suit",
    description:
      "A diamond symbol emoji, which is used in card games for the diamonds suit.",
  },
  {
    "web-scraper-order": "1666027262-1818",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♥️ Heart Suit",
    "symbols-href": "https://emojipedia.org/heart-suit/",
    emoji: "♥️",
    emojiName: "♥️ Heart Suit",
    description:
      "A heart symbol emoji, used in card games for the hearts suit. In emoji form, this is most commonly used for love, affectiction, romance and positive intentions. Sometimes shown in a slightly darker shade of red than ❤️ Red Heart.",
  },
  {
    "web-scraper-order": "1666027265-1821",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♠️ Spade Suit",
    "symbols-href": "https://emojipedia.org/spade-suit/",
    emoji: "♠️",
    emojiName: "♠️ Spade Suit",
    description:
      "A spade symbol emoji, which is used in card games for the spades suit.",
  },
  {
    "web-scraper-order": "1666027270-1824",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🌀 Cyclone",
    "symbols-href": "https://emojipedia.org/cyclone/",
    emoji: "🌀",
    emojiName: "🌀 Cyclone",
    description:
      "An icon used to represent a cyclone. Some versions of this emoji show a spiral shape, which may be used for decorative purposes.",
  },
  {
    "web-scraper-order": "1666027275-1827",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕦 Eleven-Thirty",
    "symbols-href": "https://emojipedia.org/eleven-thirty/",
    emoji: "🕦",
    emojiName: "🕦 Eleven-Thirty",
    description:
      "Eleven-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eleven-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027280-1831",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕚 Eleven O’Clock",
    "symbols-href": "https://emojipedia.org/eleven-oclock/",
    emoji: "🕚",
    emojiName: "🕚 Eleven O’Clock",
    description:
      "Eleven O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eleven O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027284-1833",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕥 Ten-Thirty",
    "symbols-href": "https://emojipedia.org/ten-thirty/",
    emoji: "🕥",
    emojiName: "🕥 Ten-Thirty",
    description:
      "Ten-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Ten-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027288-1837",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕙 Ten O’Clock",
    "symbols-href": "https://emojipedia.org/ten-oclock/",
    emoji: "🕙",
    emojiName: "🕙 Ten O’Clock",
    description:
      "Ten O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Ten O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027293-1841",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕤 Nine-Thirty",
    "symbols-href": "https://emojipedia.org/nine-thirty/",
    emoji: "🕤",
    emojiName: "🕤 Nine-Thirty",
    description:
      "Nine-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Nine-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027298-1845",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕘 Nine O’Clock",
    "symbols-href": "https://emojipedia.org/nine-oclock/",
    emoji: "🕘",
    emojiName: "🕘 Nine O’Clock",
    description:
      "Nine O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Nine O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027303-1849",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕣 Eight-Thirty",
    "symbols-href": "https://emojipedia.org/eight-thirty/",
    emoji: "🕣",
    emojiName: "🕣 Eight-Thirty",
    description:
      "Eight-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eight-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027310-1852",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕗 Eight O’Clock",
    "symbols-href": "https://emojipedia.org/eight-oclock/",
    emoji: "🕗",
    emojiName: "🕗 Eight O’Clock",
    description:
      "Eight O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eight O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027315-1856",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕢 Seven-Thirty",
    "symbols-href": "https://emojipedia.org/seven-thirty/",
    emoji: "🕢",
    emojiName: "🕢 Seven-Thirty",
    description:
      "Seven-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Seven-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027319-1860",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕖 Seven O’Clock",
    "symbols-href": "https://emojipedia.org/seven-oclock/",
    emoji: "🕖",
    emojiName: "🕖 Seven O’Clock",
    description:
      "Seven O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Seven O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027323-1864",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕡 Six-Thirty",
    "symbols-href": "https://emojipedia.org/six-thirty/",
    emoji: "🕡",
    emojiName: "🕡 Six-Thirty",
    description:
      "Six-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Six-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027328-1867",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕕 Six O’Clock",
    "symbols-href": "https://emojipedia.org/six-oclock/",
    emoji: "🕕",
    emojiName: "🕕 Six O’Clock",
    description:
      "Six O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Six O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027332-1871",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕠 Five-Thirty",
    "symbols-href": "https://emojipedia.org/five-thirty/",
    emoji: "🕠",
    emojiName: "🕠 Five-Thirty",
    description:
      "Five-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Five-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027337-1876",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕔 Five O’Clock",
    "symbols-href": "https://emojipedia.org/five-oclock/",
    emoji: "🕔",
    emojiName: "🕔 Five O’Clock",
    description:
      "Five O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Five O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027341-1878",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕟 Four-Thirty",
    "symbols-href": "https://emojipedia.org/four-thirty/",
    emoji: "🕟",
    emojiName: "🕟 Four-Thirty",
    description:
      "Four-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Four-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027347-1883",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕓 Four O’Clock",
    "symbols-href": "https://emojipedia.org/four-oclock/",
    emoji: "🕓",
    emojiName: "🕓 Four O’Clock",
    description:
      "Four O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Four O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027352-1887",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕞 Three-Thirty",
    "symbols-href": "https://emojipedia.org/three-thirty/",
    emoji: "🕞",
    emojiName: "🕞 Three-Thirty",
    description:
      "Three-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Three-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027356-1890",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕒 Three O’Clock",
    "symbols-href": "https://emojipedia.org/three-oclock/",
    emoji: "🕒",
    emojiName: "🕒 Three O’Clock",
    description:
      "Three O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Three O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027360-1894",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕝 Two-Thirty",
    "symbols-href": "https://emojipedia.org/two-thirty/",
    emoji: "🕝",
    emojiName: "🕝 Two-Thirty",
    description:
      "Two-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Two-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027363-1897",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕑 Two O’Clock",
    "symbols-href": "https://emojipedia.org/two-oclocktime/",
    emoji: "🕑",
    emojiName: "🕑 Two O’Clock",
    description:
      "Two O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Two O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027368-1901",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕜 One-Thirty",
    "symbols-href": "https://emojipedia.org/one-thirty/",
    emoji: "🕜",
    emojiName: "🕜 One-Thirty",
    description:
      "One-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face One-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027372-1904",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕐 One O’Clock",
    "symbols-href": "https://emojipedia.org/one-oclock/",
    emoji: "🕐",
    emojiName: "🕐 One O’Clock",
    description:
      "One O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face One O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027377-1908",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕧 Twelve-Thirty",
    "symbols-href": "https://emojipedia.org/twelve-thirty/",
    emoji: "🕧",
    emojiName: "🕧 Twelve-Thirty",
    description:
      "Twelve-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Twelve-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027381-1912",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕛 Twelve O’Clock",
    "symbols-href": "https://emojipedia.org/twelve-oclock/",
    emoji: "🕛",
    emojiName: "🕛 Twelve O’Clock",
    description:
      "Twelve O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Twelve O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027383-1914",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛑 Stop Sign",
    "symbols-href": "https://emojipedia.org/stop-sign/",
    emoji: "🛑",
    emojiName: "🛑 Stop Sign",
    description:
      "A red, octagonal sign. Used in many countries as a stop sign.",
  },
  {
    "web-scraper-order": "1666027386-1917",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💈 Barber Pole",
    "symbols-href": "https://emojipedia.org/barber-pole/",
    emoji: "💈",
    emojiName: "💈 Barber Pole",
    description:
      "A pole spiraled with red, white, and blue stripes, as spins out front of a barbershop. Commonly used for various content concerning haircutting and hairstyling.",
  },
  {
    "web-scraper-order": "1666027389-1920",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♨️ Hot Springs",
    "symbols-href": "https://emojipedia.org/hot-springs/",
    emoji: "♨️",
    emojiName: "♨️ Hot Springs",
    description:
      "Representation of hot springs with steam rising from a circular tub. This is the common symbol used to represent an onsen on maps in Japan.",
  },
  {
    "web-scraper-order": "1666027391-1923",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💮 White Flower",
    "symbols-href": "https://emojipedia.org/white-flower/",
    emoji: "💮",
    emojiName: "💮 White Flower",
    description:
      "A stylized white flower. Generally depicted as a rosette-shaped cherry blossom in pink or red outline, often with a white fill.",
  },
  {
    "web-scraper-order": "1666027393-1925",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💤 Zzz",
    "symbols-href": "https://emojipedia.org/zzz/",
    emoji: "💤",
    emojiName: "💤 Zzz",
    description:
      "A series of three Zs making a Zzz. Represents sleeping, snoring, dreaming, or any sleep-related state. Can also be used in some contexts to represent something that is boring.",
  },
  {
    "web-scraper-order": "1666027396-1928",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💭 Thought Balloon",
    "symbols-href": "https://emojipedia.org/thought-balloon/",
    emoji: "💭",
    emojiName: "💭 Thought Balloon",
    description:
      "A large cloud-like shape more commonly known as a thought bubble.",
  },
  {
    "web-scraper-order": "1666027398-1930",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🗯️ Right Anger Bubble",
    "symbols-href": "https://emojipedia.org/right-anger-bubble/",
    emoji: "🗯️",
    emojiName: "🗯️ Right Anger Bubble",
    description:
      "A form of speech balloon used with angular edges, used to denote angry speech in comics.",
  },
  {
    "web-scraper-order": "1666027401-1934",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🗨️ Left Speech Bubble",
    "symbols-href": "https://emojipedia.org/left-speech-bubble/",
    emoji: "🗨️",
    emojiName: "🗨️ Left Speech Bubble",
    description:
      "A left-facing speech bubble, which was included in Unicode 7.0, but not considered a standard addition for the purposes of emoji presentation.",
  },
  {
    "web-scraper-order": "1666027404-1937",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "👁️‍🗨️ Eye in Speech Bubble",
    "symbols-href": "https://emojipedia.org/eye-in-speech-bubble/",
    emoji: "👁️‍🗨️",
    emojiName: "👁️‍🗨️ Eye in Speech Bubble",
    description:
      'A speech bubble showing an eye inside. When using text-to-speech on Apple platforms, this emoji is read aloud as: "Eye in speech bubble representing anti-bullying campaign". This emoji was released in conjunction with the Ad Council for the I Am A Witness campaign.',
  },
  {
    "web-scraper-order": "1666027406-1939",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💬 Speech Balloon",
    "symbols-href": "https://emojipedia.org/speech-balloon/",
    emoji: "💬",
    emojiName: "💬 Speech Balloon",
    description:
      "A cartoon-style balloon used to represent spoken word in comics. Sometimes  used in communication apps to indicate that another person is typing a message.",
  },
  {
    "web-scraper-order": "1666027409-1941",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💢 Anger Symbol",
    "symbols-href": "https://emojipedia.org/anger-symbol/",
    emoji: "💢",
    emojiName: "💢 Anger Symbol",
    description:
      "A red symbol found in Anime/Manga and used to represent the veins popping on a very angry person.",
  },
  {
    "web-scraper-order": "1666027412-1945",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💯 Hundred Points",
    "symbols-href": "https://emojipedia.org/hundred-points/",
    emoji: "💯",
    emojiName: "💯 Hundred Points",
    description:
      "100 emoji: the number one-hundred, written in red, underlined twice for emphasis.",
  },
  {
    "web-scraper-order": "1666027416-1948",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🤍 White Heart",
    "symbols-href": "https://emojipedia.org/white-heart/",
    emoji: "🤍",
    emojiName: "🤍 White Heart",
    description:
      "A white heart emoji, used for love and affection. Also commonly used to discuss someone passing away.",
  },
  {
    "web-scraper-order": "1666027419-1951",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🖤 Black Heart",
    "symbols-href": "https://emojipedia.org/black-heart/",
    emoji: "🖤",
    emojiName: "🖤 Black Heart",
    description:
      "A heart shaded completely black. May be used to express morbidity, sorrow, or a form of dark humor, but despite the color remains most commonly used for love and affection.",
  },
  {
    "web-scraper-order": "1666027424-1955",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🤎 Brown Heart",
    "symbols-href": "https://emojipedia.org/brown-heart/",
    emoji: "🤎",
    emojiName: "🤎 Brown Heart",
    description:
      "A brown heart, often used discuss topics related to racial identity 🧑🏽🧑🏾🧑🏿",
  },
  {
    "web-scraper-order": "1666027428-1958",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💜 Purple Heart",
    "symbols-href": "https://emojipedia.org/purple-heart/",
    emoji: "💜",
    emojiName: "💜 Purple Heart",
    description:
      "A purple heart emoji, often used alongside other colored hearts. Frequently used on Twitter in reference to Korean boy band Bangtan Sonyeondan, more commonly known as BTS.",
  },
  {
    "web-scraper-order": "1666027432-1963",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💙 Blue Heart",
    "symbols-href": "https://emojipedia.org/blue-heart/",
    emoji: "💙",
    emojiName: "💙 Blue Heart",
    description:
      "A blue heart emoji, commonly used by brands as a neutral heart color.",
  },
  {
    "web-scraper-order": "1666027436-1966",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💚 Green Heart",
    "symbols-href": "https://emojipedia.org/green-heart/",
    emoji: "💚",
    emojiName: "💚 Green Heart",
    description:
      "A green heart emoji, often used alongside other colored hearts. Frequently used on Twitter in reference to Korean boy band NCT.",
  },
  {
    "web-scraper-order": "1666027440-1970",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💛 Yellow Heart",
    "symbols-href": "https://emojipedia.org/yellow-heart/",
    emoji: "💛",
    emojiName: "💛 Yellow Heart",
    description:
      "A yellow or gold colored love-heart, frequently used alongside other colored hearts. This displayed as a pink hairy heart on Android 4.4.",
  },
  {
    "web-scraper-order": "1666027444-1974",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🧡 Orange Heart",
    "symbols-href": "https://emojipedia.org/orange-heart/",
    emoji: "🧡",
    emojiName: "🧡 Orange Heart",
    description:
      "Orange Heart was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666027448-1976",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️ Red Heart",
    "symbols-href": "https://emojipedia.org/red-heart/",
    emoji: "❤️",
    emojiName: "❤️ Red Heart",
    description:
      "A classic red love heart emoji, used for expressions of love and romance. This is the most popular heart emoji A similar emoji exists for the heart suit in a deck of playing cards.",
  },
  {
    "web-scraper-order": "1666027453-1979",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️‍🩹 Mending Heart",
    "symbols-href": "https://emojipedia.org/mending-heart/",
    emoji: "❤️‍🩹",
    emojiName: "❤️‍🩹 Mending Heart",
    description:
      "A heart shown with a bandage across one side; the opposite of a broken heart. May be used to indicate the process of healing, recovery, or to express sympathy for someone going through a difficult time.",
  },
  {
    "web-scraper-order": "1666027458-1982",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️‍🔥 Heart on Fire",
    "symbols-href": "https://emojipedia.org/heart-on-fire/",
    emoji: "❤️‍🔥",
    emojiName: "❤️‍🔥 Heart on Fire",
    description:
      "A heart shown on fire, for extreme or passionate forms of love or lust. Most representative of desire or lust, this emoji may also indicate a sense of burning a past love and moving on.",
  },
  {
    "web-scraper-order": "1666027464-1984",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💔 Broken Heart",
    "symbols-href": "https://emojipedia.org/broken-heart/",
    emoji: "💔",
    emojiName: "💔 Broken Heart",
    description:
      "A love heart, broken in two. This emoji represents the aching one feels when they are missing the person they love.",
  },
  {
    "web-scraper-order": "1666027468-1986",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❣️ Heart Exclamation",
    "symbols-href": "https://emojipedia.org/heart-exclamation/",
    emoji: "❣️",
    emojiName: "❣️ Heart Exclamation",
    description:
      "A decorative exclamation mark, where a heart forms the top part of the symbol, and a circle the lower part. Similar to the way to the man in business suit levitating also creates a similar shape.",
  },
  {
    "web-scraper-order": "1666027471-1988",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💟 Heart Decoration",
    "symbols-href": "https://emojipedia.org/heart-decoration/",
    emoji: "💟",
    emojiName: "💟 Heart Decoration",
    description:
      "A decorative heart that generally displays as a white heart-shaped cutout in a pink or purple roundrect.",
  },
  {
    "web-scraper-order": "1666027474-1990",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💕 Two Hearts",
    "symbols-href": "https://emojipedia.org/two-hearts/",
    emoji: "💕",
    emojiName: "💕 Two Hearts",
    description:
      "Two pink love hearts. One larger than the other. Can be used to display that “love is in the air”.",
  },
  {
    "web-scraper-order": "1666027477-1992",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💞 Revolving Hearts",
    "symbols-href": "https://emojipedia.org/revolving-hearts/",
    emoji: "💞",
    emojiName: "💞 Revolving Hearts",
    description:
      "Hearts revolving around one or more other hearts. This emoji was originally animated on a number of Japanese devices.",
  },
  {
    "web-scraper-order": "1666027480-1993",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💓 Beating Heart",
    "symbols-href": "https://emojipedia.org/beating-heart/",
    emoji: "💓",
    emojiName: "💓 Beating Heart",
    description:
      "A heart with vibration/movement lines above it or around it, indicating it is beating. Displayed in pink or red on most platforms.",
  },
  {
    "web-scraper-order": "1666027484-1996",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💗 Growing Heart",
    "symbols-href": "https://emojipedia.org/growing-heart/",
    emoji: "💗",
    emojiName: "💗 Growing Heart",
    description:
      "A pink heart, inside a slightly larger pink heart, inside a larger-again pink heart. Intended to give the impression of a heart increasing in size.",
  },
  {
    "web-scraper-order": "1666027487-1997",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💖 Sparkling Heart",
    "symbols-href": "https://emojipedia.org/sparkling-heart/",
    emoji: "💖",
    emojiName: "💖 Sparkling Heart",
    description:
      "A pink love heart with stars around it, making it look like it is sparkling or shimmering.",
  },
  {
    "web-scraper-order": "1666027490-1999",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💝 Heart with Ribbon",
    "symbols-href": "https://emojipedia.org/heart-with-ribbon/",
    emoji: "💝",
    emojiName: "💝 Heart with Ribbon",
    description:
      "A heart-shaped box, tied with a ribbon. May be a gift box, box of chocolates, or a jewellery box.",
  },
  {
    "web-scraper-order": "1666027493-2001",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💘 Heart with Arrow",
    "symbols-href": "https://emojipedia.org/heart-with-arrow/",
    emoji: "💘",
    emojiName: "💘 Heart with Arrow",
    description:
      "A heart emoji with an arrow through the center, like the arrow that cupid shoots for love.",
  },
];

export default symbols;
